const STATUS_COLORS = {
    "VISIT FEE PENDING": "bg-amber-50 text-amber-700 border-amber-200",
    "VISIT FEE PAYMENT PENDING": "bg-amber-50 text-amber-700 border-amber-200",
    "VISIT FEE PAID": "bg-teal-50 text-teal-700 border-teal-200",
    "WAITING FOR ASSIGNMENT": "bg-amber-50 text-amber-700 border-amber-200",
    "REQUEST RECEIVED": "bg-slate-100 text-slate-700 border-slate-200",
    "PROFESSIONAL ASSIGNED": "bg-blue-50 text-blue-700 border-blue-200",
    "CONFIRMED": "bg-blue-50 text-blue-700 border-blue-200",
    "ON THE WAY": "bg-indigo-50 text-indigo-700 border-indigo-200",
    "ARRIVED": "bg-indigo-50 text-indigo-700 border-indigo-200",
    "INSPECTION": "bg-amber-50 text-amber-700 border-amber-200",
    "ESTIMATE APPROVAL REQUIRED": "bg-orange-50 text-orange-dark border-orange-200",
    "WORK IN PROGRESS": "bg-purple-50 text-purple-700 border-purple-200",
    "CUSTOMER REVIEW": "bg-orange-50 text-orange-dark border-orange-200",
    "REVISION REQUIRED": "bg-red-50 text-red-700 border-red-200",
    "WORK DONE - PAYMENT PENDING": "bg-amber-50 text-amber-700 border-amber-200",
    "COMPLETED": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "PAYMENT PENDING": "bg-amber-50 text-amber-700 border-amber-200",
    "PAID": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "CLOSED": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "CANCELLED": "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ status, className = "" }) {
    const cls = STATUS_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-200";
    return (
        <span
            data-testid="status-badge"
            className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${cls} ${className}`}
        >
            <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
            {status}
        </span>
    );
}
